import React from 'react';
import Schedule from '../../../../../src/assets/images/studio/ingestion/schedule.svg';
import ScheduleFilled from '../../../../../src/assets/images/studio/ingestion/schedule-filled.svg';
import { omit } from 'lodash';

interface ScheduleIconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  style?: React.CSSProperties;
  filled?: boolean;
}

export default function ScheduleIconComponent({ style, ...props }: ScheduleIconProps) {
  return (
    <img
      {...omit(props, 'filled')}
      alt="Schedule icon"
      src={props?.filled ? ScheduleFilled : Schedule}
      style={{ ...style }}
    />
  );
}
